import { Stack, useTheme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { ArrowRightIcon } from '@/components/icons/ArrowRightIcon';
import { WithClasses } from '@/styles/types';

import { getTileFontScale, TileThemedTypography } from './TileThemedTypography';
import { TileFontSizeVariant, TileVariant } from './types';

const useStyles = makeStyles()((_theme) => {
  return {
    before: {},
    after: {},
  };
});

export interface TileBeforeAndAfterProps {
  before: string;
  after: string;
  variant: TileVariant;
  fontSizeVariant: TileFontSizeVariant;
  classes?: WithClasses<typeof useStyles>;
}

const TYPOGRAPHY_VARIANT = 'h2light';
const BASE_ARROW_SIZE = 16;

export function TileBeforeAndAfter({
  before,
  after,
  classes: externalClasses,
  variant,
  fontSizeVariant,
}: TileBeforeAndAfterProps) {
  const { classes } = useStyles(undefined, {
    props: { classes: externalClasses },
  });
  const theme = useTheme();
  const arrowSize =
    BASE_ARROW_SIZE *
    getTileFontScale(theme, TYPOGRAPHY_VARIANT, fontSizeVariant);

  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      <TileThemedTypography
        variant={TYPOGRAPHY_VARIANT}
        tileVariant={variant}
        fontSizeVariant={fontSizeVariant}
        className={classes.before}
      >
        {before}
      </TileThemedTypography>
      <ArrowRightIcon
        sx={{
          display: 'flex',
        }}
        size={arrowSize}
      />
      <TileThemedTypography
        variant={TYPOGRAPHY_VARIANT}
        tileVariant={variant}
        fontSizeVariant={fontSizeVariant}
        className={classes.after}
      >
        {after}
      </TileThemedTypography>
    </Stack>
  );
}
